var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20629",
    "data-name": "Group 20629",
    transform: "translate(-32 -239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_11106",
    "data-name": "Path 11106",
    transform: "translate(32 239)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 1 C 11.26046943664551 1 7.744760513305664 2.456249237060547 5.100509643554688 5.100509643554688 C 2.456249237060547 7.744760513305664 1 11.26046943664551 1 15 C 1 18.73952865600586 2.456249237060547 22.25523948669434 5.100509643554688 24.89949035644531 C 7.744760513305664 27.54375076293945 11.26046943664551 29 15 29 C 18.73952865600586 29 22.25523948669434 27.54375076293945 24.89949035644531 24.89949035644531 C 27.54375076293945 22.25523948669434 29 18.73952865600586 29 15 C 29 11.26046943664551 27.54375076293945 7.744760513305664 24.89949035644531 5.100509643554688 C 22.25523948669434 2.456249237060547 18.73952865600586 1 15 1 M 15 0 C 23.28426933288574 0 30 6.715730667114258 30 15 C 30 23.28426933288574 23.28426933288574 30 15 30 C 6.715730667114258 30 0 23.28426933288574 0 15 C 0 6.715730667114258 6.715730667114258 0 15 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_787737",
    transform: "translate(32.5 233.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_169",
    "data-name": "Union 169",
    d: "M17301.816,20128.574c-.5,0-.9-.252-.9-.57v-.525c0-.318.4-.57.9-.57h3.066c.494,0,.9.252.9.57v.525c0,.318-.4.57-.9.57Zm-2.707-3.85c-.5,0-.9-.256-.9-.57v-.529c0-.314.408-.566.9-.566h8.48c.5,0,.9.252.9.566v.529c0,.314-.408.57-.9.57Zm-2.709-3.848c-.494,0-.9-.258-.9-.572v-.529c0-.314.4-.566.9-.566h13.893c.5,0,.9.252.9.566v.529c0,.314-.4.572-.9.572Z",
    transform: "translate(-17289 -20102.5)",
    fill: "#f9f9f9"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.41c3e238.svg";
export { ForwardRef as ReactComponent };